import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
interface StatCounterProps {
  end: number;
  duration?: number;
  suffix?: string;
  prefix?: string;
  label: string;
  icon: React.ReactNode;
}
export function StatCounter({
  end,
  duration = 2,
  suffix = '',
  prefix = '',
  label,
  icon
}: StatCounterProps) {
  const [count, setCount] = useState(0);
  const {
    ref,
    isIntersecting
  } = useIntersectionObserver({
    threshold: 0.5
  });
  useEffect(() => {
    if (!isIntersecting) return;
    let startTime: number | null = null;
    const startValue = 0;
    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / (duration * 1000), 1);
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentCount = Math.floor(easeOutQuart * (end - startValue) + startValue);
      setCount(currentCount);
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }, [isIntersecting, end, duration]);
  return <motion.div ref={ref} className="text-center" initial={{
    opacity: 0,
    y: 30
  }} animate={isIntersecting ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.6
  }} data-id="element-256">
      {/* Icon */}
      <div className="inline-flex text-gold mb-6" data-id="element-257">{icon}</div>

      {/* Number */}
      <div className="font-heading font-semibold text-5xl md:text-6xl text-white mb-2" data-id="element-258">
        {prefix}
        {count.toLocaleString()}
        {suffix}
      </div>

      {/* Label */}
      <div className="text-white/60 text-base font-medium" data-id="element-259">{label}</div>
    </motion.div>;
}